import { useCallback, useMemo, useState } from 'react';
export function useManageSiteDialog(plugins, siteComponents) {
    const [openedDialogEvents, setOpenedDialogEvents] = useState([]);
    // get all dialog components for the site
    const dialogs = useMemo(() => {
        const dialogTypes = plugins
            .filter(p => { var _a; return (_a = p.categories) === null || _a === void 0 ? void 0 : _a.includes('dialog'); })
            .map(p => p.type);
        return siteComponents.filter(c => dialogTypes.includes(c.type));
    }, [plugins, siteComponents]);
    /**
     * Called by the SiteEventOpenDialogPlugin to match the dialog component
     * with the calling component to render in the SiteComponentPlugin.
     */
    const openDialog = useCallback((componentId, dialog, data) => {
        setOpenedDialogEvents(openedDialogEvents => {
            const plugin = plugins.find(p => p.type === dialog.type);
            if (!plugin)
                return openedDialogEvents;
            openedDialogEvents = [...openedDialogEvents];
            const index = openedDialogEvents.findIndex(event => event.componentId === componentId && dialog.id === event.dialog.id);
            const event = { componentId, plugin, dialog, data };
            // replace existing
            index < 0
                ? openedDialogEvents.push(event)
                : openedDialogEvents.splice(index, 1, event);
            return openedDialogEvents;
        });
    }, [plugins]);
    /**
     * Called by the SiteEventCloseDialogPlugin to match the dialog component
     * with the calling component to render in the SiteComponentPlugin.
     */
    const closeDialog = useCallback((componentId, dialog) => {
        // find first occurence of dialog and close it
        setOpenedDialogEvents(dialogs => {
            const index = dialogs.findIndex(event => event.dialog.id === dialog.id);
            if (index > -1) {
                dialogs = [...dialogs];
                dialogs.splice(index, 1);
            }
            return dialogs;
        });
    }, []);
    return { dialogs, openedDialogEvents, openDialog, closeDialog };
}
//# sourceMappingURL=useManageSiteDialog.js.map